export default __webpack_public_path__ + "static/media/loading.3ad0dde3.gif";